import { ADD_BENEFICIARY, GET_BENEFICIARIES, GET_BENEFICIARIES_CORE, DELETE_BENEFICIARY, UPDATE_BENEFICIARY } from './../constants';
import { handleActions } from "redux-actions"

export const beneficiary  = handleActions(
  {
    [ ADD_BENEFICIARY ]: (state, action) =>  [...state, action.payload ], 
    [ DELETE_BENEFICIARY ]: (state, action) => {
      if (state.length > 0) {
        let result = state
        let removeIndex = result.map((item) => { return item.id }).indexOf(action.payload.id);
         return result.splice(removeIndex, 1)
      } else {
        return state
      }
      
    }, 
    [ GET_BENEFICIARIES ]: (state, action) =>  action.payload,
    [ GET_BENEFICIARIES_CORE ]: (state, action) => state,
    [ UPDATE_BENEFICIARY ]: (state, action) => {
      const result  = action.payload
            const { id } = result
            const prevState  = state
            const initialValue = []
            const newBeneficiary = prevState.reduce((acc, beneficiary) => {
                if (beneficiary.id === id) {
                  // console.log(beneficiary.id +  ' con ' + id)
                    return [...acc, result]
                } else {
                    return [...acc, beneficiary]
                }
            }, initialValue)
            return newBeneficiary
    }
  }, []
)